import { membershipApi } from 'app/src/services/welfareportal'
import { PortalConfirmDialog } from 'app/src/shared/components'
import { getFromSessionStorage } from 'app/src/shared/helpers'
import { useWebAppContext } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { useCallback, useState, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function CancelJoinSection(props: { onSuccess: () => void; onError: () => void }): ReactElement {
  const { t } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.Confirm.cancelJoinSection' })
  const [showConfirm, setShowConfirm] = useState<boolean>(false)
  const context = useWebAppContext()

  const campaignStorage = getFromSessionStorage('selectedCampaign') ?? '{}'
  const membershipId = JSON.parse(campaignStorage)?.membershipId

  const membershipMutation = membershipApi.useMembershipJoin({
    onSuccess: () => {
      props.onSuccess()
    },
    onError: (error: membershipApi.MembershipJoinError) => {
      context.logger?.error('Error Joining Membership', { propertyName: 'percentage', error })
      props.onError()
    },
  })

  const updateUserPercentage = useCallback(async () => {
    await membershipMutation.mutateAsync({
      pathParams: {
        membershipId,
      },
      body: {
        acknowledgeDocuments: [],
        percentage: 0,
        userId: context.userInfo.userId,
      },
    })
  }, [membershipMutation, context, membershipId])

  return (
    <>
      {showConfirm && (
        <PortalConfirmDialog
          accept={updateUserPercentage}
          reject={() => setShowConfirm(false)}
          body={t('unjoinConfirmationDialog.text')}
          title={t('unjoinConfirmationDialog.title')}
        />
      )}
      <div className='bg-[var(--card-background)] p-4 text-center'>
        <div>{t('text')}</div>
        <div>
          <Button link label={t('btnLabel')} onClick={() => setShowConfirm(true)}></Button>
        </div>
      </div>
    </>
  )
}
